import ContestPage from "./ContestPage";

export default class ContestNewPage extends ContestPage {
};
